<div class="app-info">
  <div class="title">Let's add your staff</div>
  <div class="sub-title">How would you like to add your staff?</div>
  <hr>
  <mat-radio-group
    [formControl]="renderComponent"
    (change)="manualOrCsvAddStaff()"
    class="radio-buttton-group">
    <mat-radio-button [value]="ADD_STAFF_PAGE_NUMBER.manualAddStaffPage" automation-id="add-staff-info-manual">
      <label>Add them Individually<span>(Add your staff one at a time)</span></label>
    </mat-radio-button>
    <mat-radio-button [value]="ADD_STAFF_PAGE_NUMBER.csvUploadAddStaffPage" automation-id="add-staff-info-csv-upload">
      <label>
        Upload a Spreadsheet<span>(Add your staff with a file you upload)</span>
      </label>
    </mat-radio-button>
  </mat-radio-group>
  <hr>
</div>
